const footerLinks = [
  { name: 'Recruitment & Staffing', url: 'https://www.opt4solution.site/' },
  { name: 'HR & Payroll', url: 'https://www.opt4solution.site/' },
  { name: 'OPT4Solution Store', url: 'https://www.opt4solution.store/' },
  { name: 'VRSJobs Portal', url: 'https://www.vrsjobs.com/' },
  { name: 'Tech Solutions', url: 'https://www.vrsamadhantech.com/' },
  { name: 'Other Solutions', url: 'https://www.vrsamadhantech.com/' }
];

function Footer() {
  return (
    <footer id="contact" className="border-t border-slate-200 bg-white">
      <div className="mx-auto grid max-w-7xl gap-10 px-6 py-14 lg:grid-cols-[1.1fr_0.9fr_0.9fr] lg:px-8">
        <div>
          <img
            src="https://opt4crm.com/images/OPT4CRM-LOGO.svg"
            alt="Opt4CRM logo"
            className="h-11 w-auto"
          />
          <h3 className="text-lg font-extrabold text-[#0A2540] mt-3">VRSamadhan (Opt4Solution Private Limited)</h3>
          <p className="mt-5 max-w-md leading-7 text-slate-600">
            Your one-stop solution for corporate success. We offer affordable recruitment, outsourcing, tech development, gifting, and more to help your business thrive.
          </p>
        </div>

        <div>
          <h3 className="text-lg font-extrabold text-[#0A2540]">Other Services and Products</h3>
          <div className="mt-5 flex flex-col gap-3 text-slate-600">
            {footerLinks.map((link) => (
              <a
                key={link.name}
                href={link.url}
                className="transition hover:text-[#0B5ED7]"
              >
                {link.name}
              </a>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-lg font-extrabold text-[#0A2540]">Contact</h3>
          <div className="mt-5 space-y-3 text-slate-600">
            <p>Opt4Solution Private Limited <br/> FB-05, 1st Floor, Highland Corporate Centre, Samata Nagar, Kapurbawdi, Thane West, Thane, Maharashtra 400607</p>
            <p> +91 88506 71139 / +91 22-49698274</p>
            <p>sales@vrsamadhantech.com</p>
          </div>
        </div>
      </div>
      <div className="border-t border-slate-200">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-6 py-5 text-sm text-slate-500 sm:flex-row sm:items-center sm:justify-between lg:px-8">
          <p>Designed and Developed By: VRSamadhan Tech</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
